import module from './footers.module'

export default module.name
